var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowWorkRowIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#8A90FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 14C33.8195 14 36 16.1805 36 18.8889V36H18.8889C16.1805 36 14 33.8195 14 31.1111V18.8889C14 16.1805 16.1805 14 18.8889 14H31.1111ZM29.3814 17.6714C29.0689 17.6714 28.7567 17.7911 28.5173 18.0305L27.6531 18.8947L31.1101 22.3516L31.9742 21.4874C32.453 21.0086 32.453 20.2376 31.9742 19.7588L30.2456 18.0305C30.0062 17.7911 29.6938 17.6714 29.3814 17.6714ZM26.789 19.7588L17.6668 28.8761V32.3332H21.1239L30.2456 23.2155L26.789 19.7588Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowWorkRowIcon3);
export default __webpack_public_path__ + "static/media/how-work-row-icon3.a26a3f193e0db3c5a63537fdfd4c381d.svg";
export { ForwardRef as ReactComponent };